import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { AIS_TAB_NAME, isAisLinkPage, isAisSignedOutPage } from './aisSignin';
import { useAisIdentity } from './useAisIdentity';

// The AIS reuses its open tab by this name, so no other tab may carry it; the signed-out page cannot take a link
export const useAisTabName = (): void => {
  const { isLoading } = useAuth();
  const aisTab = useAisIdentity() !== null && !isAisSignedOutPage();
  useEffect(() => {
    // the link page names the tab itself before it leaves for the login; a loading user is not yet known
    if (isLoading || isAisLinkPage()) return;
    window.name = aisTab ? AIS_TAB_NAME : '';
  }, [aisTab, isLoading]);
};
